module.exports = __webpack_public_path__ + "img/play.1c897dda.png";